var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"link-item",style:({ cursor: 'pointer', color:'black !important', fontSize:'large'}),on:{"click":function($event){return _vm.show_user()}}},[_vm._v(" "+_vm._s(this.username_by_id(this.user.id))+" ")]),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }